<script setup lang="ts">
import { useImage } from "@vueuse/core";
import { Scarcity } from "fungi-types";
import { computed, ref, onMounted } from "vue";

const props = defineProps<{
  src: string;
  alt: string;
  scarcity?: Scarcity;
  aspectRatio?: number;
}>();

const containerRef = ref<HTMLDivElement | null>(null);
const { isLoading, isReady, error } = useImage({ src: props.src, alt: props.alt });

const loadingUrl = computed(() => {
  switch (props.scarcity) {
    case Scarcity.GOLD:
      return "https://storage.googleapis.com/fungiball-assets/pack-opening/card_back_gold_600x600.png";
    case Scarcity.SILVER:
      return "https://storage.googleapis.com/fungiball-assets/pack-opening/card_back_silver_600x600.png";
    case Scarcity.PLATINUM:
      return "https://storage.googleapis.com/fungiball-assets/pack-opening/card_back_platinum_600x600.png";
    default:
      return "https://storage.googleapis.com/fungiball-assets/pack-opening/card_back_silver_600x600.png";
  }
});
</script>

<template>
  <div
    ref="containerRef"
    class="relative overflow-hidden max-h-[402px] hover:scale-[103%] transform transition-transform"
    :style="aspectRatio ? `aspect-ratio: ${aspectRatio}` : ''"
  >
    <div
      v-if="error"
      :style="`aspect-ratio: ${aspectRatio}`"
      class="bg-zinc-500 rounded-md overflow-hidden max-h-[400px]"
    >
      <p class="pt-f4 text-center small-text">{{ alt }}</p>
    </div>
    <img v-else-if="isLoading || !isReady" :src="loadingUrl" class="w-full animate-pulse" />
    <img v-show="!isLoading && isReady" :src="src" :alt="alt" class="w-full object-contain" />
  </div>
</template>

<style scoped></style>
